// extracted by mini-css-extract-plugin
module.exports = {"containerXL":"ContainerXL_containerXL__szzF5"};